(ns frontend.ui.component.text-group.view
  (:require
   [frontend.ui.component.label.view :refer [label]]
   [frontend.ui.component.text.view :refer [text]]))

(defn text-group
  [title value]
  [label
   [text
    {:font-weight :semi-bold}
    title]
   [:div
    [text
     {:font-weight :regular}
     (str value)]]])
